export const stationList = [
  // Major Metros (to maintain original functionality)
  'New Delhi', 'Mumbai', 'Bangalore', 'Kolkata', 'Hyderabad', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow',

  // 50+ Major Tamil Nadu Stations (Exact Dataset Matches)
  'CHENNAI CENTRAL', 'CHENNAI EGMORE', 'TAMBARAM', 'MADURAI JN',
  'COIMBATORE JN', 'TIRUCHCHIRAPPALLI', 'SALEM JN', 'TIRUNELVELI',
  'ERODE JN', 'KATPADI JN', 'DINDIGUL JN', 'THANJAVUR JN',
  'ARAKKONAM', 'VILLUPURAM JN', 'TIRUPPUR', 'KANNIYAKUMARI',
  'TUTICORIN', 'RAMESWARAM', 'VELLORE CANTT', 'CHENGALPATTU',
  'KANCHIPURAM', 'KUMBAKONAM', 'MAYILADUTURAI J', 'NAGAPPATTINAM',
  'CUDDALORE PORT', 'VIRUDHACHALAM JN', 'SRIRANGAM', 'KARUR',
  'NAMAKKAL', 'HOSUR', 'DHARMAPURI', 'TIRUVANNAMALAI',
  'AMBUR', 'VANIYAMBADI', 'JOLARPETTAI', 'TIRUVALLUR',
  'AVADI', 'PERAMBUR', 'SRIVILLIPUTTUR', 'RAJAPALAYAM',
  'TENKASI JN', 'KOVILPATTI', 'VIRUDUNAGAR JN', 'PARAMAKKUDI',
  'RAMANATHAPURAM', 'SIVAGANGA', 'MANAMADURAI JN', 'KARAIKKUDI JN',
  'PUDUKKOTTAI', 'POLLACHI JN', 'UDUMALAI PРETTAI', 'PALANI',
  'METTUPALAYAM', 'NAGERCOIL JN', 'CHIDAMBARAM', 'ARUPPUKKOTTAI'
].sort();

export default stationList;
